import { Fragment, useMemo } from "react";
import { Link } from "react-router-dom";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "../../../store/store";
import "./viags-slider.scss";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.scss";
import "swiper/modules/navigation/navigation.scss";
import { CreateNotification } from "../../../components/notifier";

const useSlide = () => {
  const userAdmin = useSelector((state) => state.userAdmin);

  const slides = useMemo(() => {
    return [
      {
        to: "/document",
        imgSrc: "/assets/images/document-girl.gif",
        title: "Quản lí tài liệu",
        description:
          "Quản lí tất cả các tài liệu trên hệ thống VIAGS bao gồm các chức năng như xem thông tin, chỉnh sửa, phân quyền tài liệu, v..v.",
        havePermission: !!userAdmin?.id,
      },
      {
        to: "/document?status=publish",
        imgSrc: "/assets/images/document-promulgate.gif",
        title: "Tài liệu ban hành",
        description:
          "Hiển thị các tài liệu đã được ban hành, người dùng có thể xem thông tin hoặc thảo luận về các tài liệu này.",
        havePermission: true,
      },
      {
        to: "/statistic",
        imgSrc: "/assets/images/company-statistic-graph.gif",
        title: "Thống kê",
        description:
          "Thống kê các loại tài liệu có trên hệ thống của Viags, chức năng này hỗ trợ người dùng trong việc thống kê các loại tài liệu hiện hành hoặc hết hạn.",
        havePermission: !!userAdmin?.id,
      },
      {
        to: "/setting",
        imgSrc: "/assets/images/settings.gif",
        title: "Cấu hình",
        description:
          "Chức năng cấu hình tài liệu bao gồm các chức năng chính như: Phân quyền, quản lý loại tài liệu, quản lý bộ phần phát hành...",
        havePermission: !!userAdmin?.id,
      },
    ];
  }, [userAdmin]);

  return slides;
};

const ViagsSlider = () => {
  const userAdmin = useSelector((state) => state.userAdmin);
  const slides = useSlide();

  const handleNotify = () => {
    CreateNotification({
      title: "Thông báo",
      body: `Tính năng đang được thực hiện, sẽ triển khai cho anh/chị trong thời gian sớm nhất. Xin cảm ơn !`,
      icon: "/icons/warning.png",
    });
  };

  return (
    <div className="viags-slider-wrapper">
      <h4>HỆ THỐNG QUẢN LÝ TÀI LIỆU VIAGS</h4>
      <Swiper
        slidesPerView={userAdmin?.id ? 2 : 1}
        loop={true}
        loopFillGroupWithBlank={true}
        spaceBetween={20}
        pagination={{ clickable: true }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="viags-slider"
      >
        {slides.map((slide, index) => {
          const { description, imgSrc, title, to, havePermission } = slide;

          if (!havePermission) {
            return <Fragment key={index} />;
          }

          const content = (
            <>
              <img src={imgSrc} alt={title} />
              <h6>{title}</h6>
              <p title={description}>{description}</p>
            </>
          );

          return (
            <SwiperSlide key={index}>
              {to ? (
                <Link to={to}>{content}</Link>
              ) : (
                <div role="button" onClick={handleNotify}>
                  {content}
                </div>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ViagsSlider;
